import * as React from 'react';
import { StyleSheet , Platform, Dimensions} from 'react-native';

import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { RootStackParamList } from './types';

const { width, height } = Dimensions.get('window')

// Screens base app mobile
import DiscBackMob from './screens/DiscBack';
import DiscFrontMob from './screens/DiscFront';
import Instructions from './screens/Instructions';
import SharedMob from './screens/Shared';
import Credits from './screens/Credits';

// Screens base app desktop
import DiscFrontDesktop from './screens/desktop/DiscFrontDesktop';
import DiscBackDesktop from './screens/desktop/DiscBackDesktop';
import SharedDesktop from './screens/desktop/SharedDesktop';
import Home from './screens/Home';


const DiscFront = Platform.select({
  ios: () => DiscFrontMob,
  android: () => DiscFrontMob,
  default: () =>  width <= 800 ? DiscFrontMob:DiscFrontDesktop,
})();

const DiscBack = Platform.select({
  ios: () => DiscBackMob,
  android: () => DiscBackMob,
  default: () =>   width <= 800 ? DiscBackMob:DiscBackDesktop
})();

const Shared = Platform.select({
  ios: () => SharedMob,
  android: () => SharedMob,
  default: () =>  width <= 800 ? SharedMob : SharedDesktop
})();

// Resorcs
import NavBarContainer from './components/Nav/NavBarContainer';
import ModalDetails from './screens/ModalDetails';
import ModalTri from './screens/ModalTri';
import ModalNav from './screens/ModalNav';
import { themePattern } from './constants/pattern';





const Stack = createNativeStackNavigator<RootStackParamList>();

function App() {
  return (


    <NavigationContainer >
      <Stack.Navigator initialRouteName="Home">
        <Stack.Group screenOptions={{ statusBarHidden: true}}>
          <Stack.Screen name="Home" component={Home} options={{ title: "DISCO DE AMINOÁCIDOS", headerShown: false }} />
          
        </Stack.Group>
        <Stack.Group screenOptions={{ headerBackButtonMenuEnabled: false, headerTitleStyle: styles.title }}>
          <Stack.Screen name="DiscFront" component={DiscFront} options={{ title: "DISCO DE AMINOÁCIDOS", headerTitleStyle: styles.title }} />
          <Stack.Screen name="DiscBack" component={DiscBack} options={{ title: "TABELA DE CÓDIGO GENÉTICO", headerBackVisible: false }} />
        </Stack.Group>
        <Stack.Group screenOptions={{ presentation: 'card', headerTitleStyle: styles.title }}>

          <Stack.Screen name="ModelInfo" component={ModalDetails} options={{ title: "INFORMAÇÕES" }} />
          <Stack.Screen name="ModelTri" component={ModalTri} options={{ title: "VISUALIZAÇÃO 3D" }} />
          <Stack.Screen name="ModalNav"  component={ModalNav} options={{ title: "OPÇÕES" }} />

        </Stack.Group>
        <Stack.Group screenOptions={{ presentation: 'modal', headerTitleStyle: styles.title }}>
          <Stack.Screen name="Instructions" component={Instructions} options={{ title: "INSTRUÇÕES" }} />
          <Stack.Screen name="Shared" component={Shared} options={{ title: "COMPARTILHAR" }} />
          <Stack.Screen name="Credits" component={Credits} options={{ title: "CRÉDITOS" }} />
        </Stack.Group>
      </Stack.Navigator>
      {/* <NavBarContainer   /> */}
    </NavigationContainer>
  );
}



const styles = StyleSheet.create({
  title: {
    color: themePattern.mobile.color1,
    fontWeight: 'bold'
  },
});

export default App;